// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1hdoH","itemTitle":"ClientEmergencyInfo_itemTitle__32mUB","itemText":"ClientEmergencyInfo_itemText__3pk03"};